import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Input from "./Input";

const LANGUAGES = ["en", "es", "fr", "pt", "ru"];

const TranslatableFields = ({fields, entity, register, errors}) => {

    const {t} = useTranslation();
    const [active, setActive] = useState(0);

    const renderInput = (lang, field) => {
        const isEn = lang === "en";
        const registerKey = isEn ? field.name : `translations.${lang}.${field.name}`;
        const defaultValue = isEn
            ? entity?.[field.name] ?? ""
            : entity?.translations?.[lang]?.[field.name] ?? "";
        const error = isEn ? errors?.[field.name] : undefined;
        const rules = isEn && field.required
            ? {required: t("validation.required")}
            : undefined;

        return (
            <Input
                key={`${lang}.${field.name}`}
                defaultValue={defaultValue}
                label={t(`label.${field.name}`)}
                multiline={field.multiline}
                maxRows={field.multiline ? 4 : undefined}
                error={error}
                {...register(registerKey, rules)}
            />
        );
    };

    return (
        <Box>
            <Tabs
                value={active}
                onChange={(_, v) => setActive(v)}
                variant="scrollable"
                scrollButtons="auto"
            >
                {LANGUAGES.map(lang => (
                    <Tab key={lang} label={t(`tab.language.${lang}`)}/>
                ))}
            </Tabs>
            {LANGUAGES.map((lang, idx) => (
                <Box
                    key={lang}
                    role="tabpanel"
                    hidden={active !== idx}
                    sx={{pt: 1}}
                >
                    {fields.map(field => renderInput(lang, field))}
                </Box>
            ))}
        </Box>
    );

};

export default TranslatableFields;
